import { ArrowRight, ChevronDown, Sparkles } from "lucide-react";
import { AnimateIn } from "@/hooks/useAnimations";
import { scrollToSection } from "@/lib/scrollToSection";

export default function HeroSection({ onGetStarted }) {
  const scrollTo = (id) => scrollToSection(id);

  return (
    <section data-testid="hero-section" className="relative min-h-[85vh] sm:min-h-screen flex items-center justify-center overflow-hidden pt-20 sm:pt-24">
      <div className="absolute inset-0 bg-[#0A0A0A]">
        <div className="absolute inset-0 bg-gradient-to-b from-red-950/20 via-transparent to-[#0A0A0A]" />
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600/5 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-red-600/3 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-red-600/5 rounded-full animate-[spin_60s_linear_infinite]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-white/5 rounded-full animate-[spin_40s_linear_infinite_reverse]" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 overflow-hidden py-4 opacity-10">
        <div className="animate-marquee whitespace-nowrap flex">
          {[...Array(4)].map((_, i) => (
            <span key={i} className="text-[8rem] sm:text-[12rem] font-black uppercase tracking-tighter text-outline mx-4">
              KOKO SITES &middot; WEB DESIGN &middot; KAMRAN AZIZ &middot; INDIA &middot;&nbsp;
            </span>
          ))}
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <AnimateIn delay={0.18}>
          <p className="text-[10px] sm:text-sm font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-red-600 mb-4 sm:mb-6">
            <span className="inline-block w-2 h-2 bg-red-600 mr-3 align-middle animate-pulse" />
            Web Design Studio &middot; Bolpur Santiniketan
          </p>
        </AnimateIn>
        <AnimateIn delay={0.36}>
          <h1 className="text-4xl sm:text-5xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.9] mb-6">
            We Build<br />
            <span className="text-red-600 inline-block hover:scale-110 hover:rotate-[-2deg] transition-transform duration-300 cursor-pointer glitch-hover">Websites</span><br />
            That Convert
          </h1>
        </AnimateIn>
        <AnimateIn delay={0.54}>
          <p className="text-base sm:text-lg text-zinc-400 max-w-2xl mx-auto mb-10 leading-relaxed">
            KoKo Sites crafts high-performance, stunning websites for businesses across India.
            From local shops in Bolpur Santiniketan to enterprises in Mumbai, Delhi & Bangalore — we turn your vision into digital reality. Starting at just Rs 15,000.</p>
        </AnimateIn>
        <AnimateIn delay={0.72}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5">
            <button
              onClick={onGetStarted}
              data-testid="hero-get-started-btn"
              className="btn-brutal btn-shine group bg-red-600 text-white font-bold uppercase tracking-widest py-3 sm:py-4 px-8 sm:px-10 border-2 border-white hover:bg-white hover:text-black text-xs sm:text-sm w-full sm:w-auto"
            >
              <Sparkles className="inline mr-2 group-hover:rotate-12 transition-transform" size={14} /> Get Your Website <ArrowRight className="inline ml-2 group-hover:translate-x-1 transition-transform" size={16} />
            </button>
            <button
              onClick={() => scrollTo("#contact")}
              data-testid="hero-contact-button"
              className="btn-brutal-ghost bg-transparent text-white font-bold uppercase tracking-widest py-3 sm:py-4 px-8 sm:px-10 border-2 border-white/60 hover:bg-white hover:text-black text-xs sm:text-sm w-full sm:w-auto"
            >
              Contact Us
            </button>
          </div>
        </AnimateIn>

        <AnimateIn delay={0.9}>
          <div className="mt-12 sm:mt-16">
            <button
              onClick={() => scrollTo("#about")}
              aria-label="Scroll to about"
              className="text-zinc-500 hover:text-red-500 transition-colors animate-bounce inline-flex items-center justify-center w-10 h-10"
            >
              <ChevronDown size={24} />
            </button>
          </div>
        </AnimateIn>
      </div>
    </section>
  );
}
